var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"liveblog-viewer",style:(_vm.currentCustomCssVariables),attrs:{"id":"viewer"}},[(_vm.isAmp)?_c('DisplayAmp'):_c('Display',{ref:"display",attrs:{"active-tab":_vm.activeTab,"toggle-tab":_vm.toggleTab,"load-more-posts":_vm.loadMorePosts,"is-loading-more-posts":_vm.isLoadingMorePosts}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }